<template>
  <router-link :to="{ name: 'category', params: { id: data.id } }" class="category-card">
    <div class="category-card__text">
      <h4>{{ data.title }}</h4>
      <span class="category-card__route"
        >Подробнее
        <IconComponent name="arrow-right" />
      </span>
    </div>
    <ImgComponent :head_img="data.img" class="category-card__img" />
  </router-link>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import ImgComponent from "components/ImgComponent.vue";
export default {
  name: "CategoryCard",
  props: {
    data: {
      type: Object,
    },
  },
  components: { ImgComponent, IconComponent },
};
</script>

<style lang="stylus">
.category-card {
  display flex
  padding 10px 10px 10px 30px
  justify-content space-between
  box-shadow: 0 4px 43px #EAEAF2;
  border-radius: var(--main-radius);
  background var(--white)
  align-items center
  //max-width 460px

  &:hover {
    .category-card__route {
      color: var(--main);
      svg path {
        fill var(--main)
      }
    }
  }
  h4 {
    font-weight: 400;
    color var(--black) !important
  }

  &__text {
    display flex
    flex-direction column
    gap 30px
  }

  h4 {
    font-width 400
  }

  &__route {
    cursor pointer
    display flex
    gap 4px
    align-items: center;
    font-weight: 500;
    font-size: 0.725em;
    line-height: 160%;
    color: var(--red);
    transition var(--transition)

    &:hover {
      color: var(--main);
      svg path {
        fill var(--main)
      }
    }
    svg {
      width: 22px;
      path {
        fill var(--red)
        transition var(--transition)
      }
    }
  }
 &__img {
   max-width 130px
   max-height 130px
   border-radius 5px

   +below(1024px) {
     max-width 94px
     max-height 94px
   }
 }
}
</style>
